import { render, staticRenderFns } from "./EncounterList.vue?vue&type=template&id=0f6793b2"
import script from "./EncounterList.vue?vue&type=script&lang=js"
export * from "./EncounterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6793b2')) {
      api.createRecord('0f6793b2', component.options)
    } else {
      api.reload('0f6793b2', component.options)
    }
    module.hot.accept("./EncounterList.vue?vue&type=template&id=0f6793b2", function () {
      api.rerender('0f6793b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/components/EncounterList.vue"
export default component.exports